import o from "./index210.mjs";
import i from "./index205.mjs";
import m from "./index212.mjs";
function s(e, t) {
  m(2, arguments);
  var r = i(e), a = o(t);
  return isNaN(r.getTime()) ? /* @__PURE__ */ new Date(NaN) : (r.setFullYear(a), r);
}
export {
  s as default
};
//# sourceMappingURL=index283.mjs.map
